import React from 'react'

import { connect } from 'react-redux'
import TabContent from 'components/tab-content/tab-content'

import CapacityTeam from './capacity-team'
import AlertBanner from 'components/alerts/alert-banner'

import {
    getCurrentAccount,
} from 'state/selectors'

const Capacity = ({
    allTeams,
    accountData,
    selectedDates: {
        start,
        end
    }
}) => {
    const accountTeams = (accountData.teams_included_in_capacity || []).map(teamId => {
        return allTeams[teamId]
    }).filter(Boolean)

    const tabs = accountTeams.sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1
        return 0
    }).map(team => {
        return {
            id: team.id,
            name: team.name,
            props: {
                team,
                startMoment: start,
                endMoment: end
            },
            Component: CapacityTeam
        }
    })

    const alertCopy = (() => {
        const teamsIncluded = accountData.teams_included_in_capacity || []
        const totalTeams = accountData.teams || []

        if(!totalTeams.length){
            return {
                title: `You don't have any teams.`,
                body: `Hop over to 'People' to create a team.`
            }
        }

        if(!teamsIncluded.length){
            return {
                title: `You haven't selected any teams.`,
                body: `Click 'Visible teams' to select teams to show.`
            }
        }

        return null
    })()

    return (
        <div>
            { alertCopy ?
                <AlertBanner
                    title={alertCopy.title}
                    body={alertCopy.body}
                />
            :
                <TabContent tabs={tabs}/>
            }
        </div>
    )
}

const mapStateToProps = state => {
    return {
        allTeams: state.account.entities.teams,
        accountData: getCurrentAccount(state),
    }
}

export default connect(mapStateToProps, {

})(Capacity)


// WEBPACK FOOTER //
// ./src/sections/planning/capacity.jsx